import React, { useState } from 'react';

function Toppers() {
  const [selectedYear, setSelectedYear] = useState('2024');

  const toppersByYear = {
    '2024': [
      { name: 'Priya Sharma', grade: 'Class X', percentage: '98.5%', subjects: 'Science, Math', img: 'https://picsum.photos/150/150?random=10', rank: 1 },
      { name: 'Rahul Kumar', grade: 'Class X', percentage: '97.2%', subjects: 'Math, English', img: 'https://picsum.photos/150/150?random=11', rank: 2 },
      { name: 'Ananya Reddy', grade: 'Class IX', percentage: '96.8%', subjects: 'All Subjects', img: 'https://picsum.photos/150/150?random=12', rank: 1 },
      { name: 'Arjun Patel', grade: 'Class IX', percentage: '95.5%', subjects: 'Science, Social', img: 'https://picsum.photos/150/150?random=13', rank: 2 },
      { name: 'Sneha Iyer', grade: 'Class VIII', percentage: '97.0%', subjects: 'All Subjects', img: 'https://picsum.photos/150/150?random=14', rank: 1 },
      { name: 'Karthik Menon', grade: 'Class VIII', percentage: '94.8%', subjects: 'Math, Science', img: 'https://picsum.photos/150/150?random=15', rank: 2 }
    ],
    '2023': [
      { name: 'Divya Singh', grade: 'Class X', percentage: '97.8%', subjects: 'All Subjects', img: 'https://picsum.photos/150/150?random=16', rank: 1 },
      { name: 'Aditya Rao', grade: 'Class X', percentage: '96.5%', subjects: 'Science, Math', img: 'https://picsum.photos/150/150?random=17', rank: 2 },
      { name: 'Meera Nair', grade: 'Class IX', percentage: '95.9%', subjects: 'All Subjects', img: 'https://picsum.photos/150/150?random=18', rank: 1 },
      { name: 'Rohan Desai', grade: 'Class IX', percentage: '94.7%', subjects: 'Math, English', img: 'https://picsum.photos/150/150?random=19', rank: 2 }
    ]
  };

  const getRankColor = (rank) => {
    if (rank === 1) return '#FFD700';
    if (rank === 2) return '#C0C0C0';
    return '#CD7F32';
  };

  const getRankIcon = (rank) => {
    if (rank === 1) return 'fa-crown';
    if (rank === 2) return 'fa-medal';
    return 'fa-award';
  };

  return (
    <section style={{background: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)', minHeight: '100vh', padding: '120px 0 80px 0'}}>
      <div className="container">
        <div style={{textAlign: 'center', marginBottom: '60px'}}>
          <h2 style={{fontSize: '4rem', color: '#f8bbd0', fontWeight: 900, marginBottom: '20px'}}>Academic Toppers</h2>
          <p style={{fontSize: '1.4rem', color: '#fce4ec', maxWidth: '800px', margin: '0 auto'}}>Celebrating excellence and dedication of our bright students</p>
        </div>

        <div style={{display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '50px'}}>
          {Object.keys(toppersByYear).map((year) => (
            <button
              key={year}
              onClick={() => setSelectedYear(year)}
              style={{
                padding: '15px 40px',
                borderRadius: '30px',
                border: selectedYear === year ? '2px solid #ba68c8' : '2px solid transparent',
                background: selectedYear === year ? 'rgba(186, 104, 200, 0.2)' : 'rgba(255, 255, 255, 0.1)',
                color: selectedYear === year ? '#ba68c8' : '#fce4ec',
                fontSize: '1.1rem',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.background = 'rgba(186, 104, 200, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                if (selectedYear !== year) {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                }
              }}
            >
              {year}
            </button>
          ))}
        </div>

        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '35px'}}>
          {toppersByYear[selectedYear].map((topper, i) => (
            <div
              key={i}
              style={{
                background: 'white',
                borderRadius: '20px',
                padding: '35px 25px',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                border: `2px solid ${getRankColor(topper.rank)}`,
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
<div style={{position: 'relative', display: 'inline-block', marginBottom: '25px'}}>
                <img
                  src={topper.img}
                  alt={topper.name}
                  style={{
                    width: '150px',
                    height: '150px',
                    borderRadius: '50%',
                    border: `4px solid ${getRankColor(topper.rank)}`,
                    objectFit: 'cover',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: '-8px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: getRankColor(topper.rank),
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <i className={`fas ${getRankIcon(topper.rank)}`} style={{color: '#1a237e', fontSize: '0.9rem'}}></i>
                </div>
              </div>

              <h3 style={{color: '#1a237e', fontSize: '1.3rem', marginBottom: '8px', fontWeight: 700}}>{topper.name}</h3>
              
              <div style={{
                background: '#1a237e',
                color: 'white',
                padding: '8px 20px',
                borderRadius: '20px',
                display: 'inline-block',
                marginBottom: '12px',
                fontSize: '1.4rem',
                fontWeight: 800
              }}>
                {topper.percentage}
              </div>

              <p style={{color: '#5c6bc0', fontSize: '1rem', fontWeight: 600, marginBottom: '6px'}}>{topper.grade}</p>
              <p style={{color: '#64748b', fontSize: '0.9rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'}}>
                <i className="fas fa-book-open" style={{color: '#ba68c8'}}></i>
                {topper.subjects}
              </p>
            </div>
          ))}
        </div>

        <div style={{marginTop: '60px', background: 'white', padding: '35px', borderRadius: '15px', textAlign: 'center', boxShadow: '0 10px 30px rgba(0,0,0,0.2)'}}>
          <p style={{fontSize: '1.1rem', color: '#1a237e', lineHeight: 1.8, maxWidth: '900px', margin: '0 auto', fontWeight: 500}}>
            "Excellence is achieved through dedication, perseverance, and a commitment to continuous learning."
          </p>
        </div>
      </div>
    </section>
  );
}

export default Toppers;
